import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./About.css";
import a from "../images/about.webp";

export default function About() {
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "15%"]);

  const textVariants = {
    hidden: { y: 60, opacity: 0 },
    visible: (i = 1) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: i * 0.15,
        duration: 0.8,
        ease: "easeOut",
      },
    }),
    exit: { y: -60, opacity: 0, transition: { duration: 0.5 } },
  };

  return (
    <section id="about" className="about">
      {/* Image side */}
      <motion.div
        className="about-image"
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ amount: 0.4, once: false }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{ y }}
      >
        <motion.img
          src={a}
          alt="AnikieLab Founder"
          whileHover={{ scale: 1.05, rotate: -2 }}
          transition={{ type: "spring", stiffness: 100 }}
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
      </motion.div>

      {/* Text side */}
      <motion.div
        className="about-text"
        initial="hidden"
        whileInView="visible"
        exit="exit"
        viewport={{ amount: 0.3, once: false }}
      >
        <motion.h2 variants={textVariants} custom={1}>
          About <span>ANKITA MALI</span>
        </motion.h2>

        <motion.h3 variants={textVariants} custom={2}>
          <span>CREATIVE DIMENSION</span>
        </motion.h3>

        <motion.h5 variants={textVariants} custom={3}>
          <span>Where imagination meets precision.</span>
        </motion.h5>

        <motion.p variants={textVariants} custom={4}>
          I design stunning 3D visuals, from concept to final render. Whether
          it’s games, films, CGI ads, or teaching this one woman studio turns
          visions into captivating realities.
        </motion.p>

        <motion.p variants={textVariants} custom={5}>
          Creativity isn’t just a skill here it’s a superpower.
        </motion.p>

        <motion.a
          href="#projects"
          className="btn"
          variants={textVariants}
          custom={6}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.95 }}
        >
          Social Media
        </motion.a>
      </motion.div>
    </section>
  );
}
